import React from "react";
import searchIcon from "../../assets/search-icon.svg";

export default function SearchBar({ value, onChange, ariaLabel }) {
    return (
        <div className="flex items-end gap-[14px] w-full max-w-[367px] border-b border-[#1c2938] pb-[6px]">
            <input
                type="search"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                aria-label={ariaLabel}
                className="flex-1 min-w-0 bg-transparent outline-none text-[20px] text-[#1c2938] placeholder:text-[#a4a9af]"
            />
            <img alt="" src={searchIcon} className="w-[23px] h-[27px]" />
        </div>
    );
}
